import React, { useState, useEffect } from "react";
import "../App.css";
import ReactLoading from "react-loading";
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import axios from "axios";
import authHeader from "../services/auth-header";
import BootstrapSwitchButton from "bootstrap-switch-button-react";

import ToolkitProvider, {
  ClearSearchButton,
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";

export default function Table(props) {
  if (props.invalidtoken == "Token is invalid !!") {
    localStorage.clear();
    window.location.reload();
  }

  const [deviceStatus, setDeviceStatus] = useState("");
  const [rowImei, setRowImei] = useState("");
  const { SearchBar, ClearSearchButton } = Search;
  const { ExportCSVButton } = CSVExport;

  const API_URL = `https://atmos.urbansciences.in/adpl/updateShare/imei/${rowImei}/status/${deviceStatus}`;

  useEffect(() => {
    axios({
      method: "get",
      url: API_URL,
      headers: authHeader(),
    }).then((response) => console.log(response.data));
  }, [API_URL]);

  const columns = [
    {
      dataField: "serial_no",
      text: "S.No",
      sort: true,
      editable: false,
      headerStyle: () => {
        return { width: "5%" };
      },
    },
    {
      dataField: "imei",
      text: "Monitor Id",
      sort: true,
      editable: false,
    },
    {
      dataField: "city",
      text: "City",
      sort: true,
      editable: false,
    },
    {
      dataField: "state",
      text: "State",
      sort: true,
      editable: false,
    },
    {
      dataField: "locality",
      text: "Locality",
      sort: true,
      editable: false,
    },
    {
      dataField: "coordinates1",
      text: "Latitude",
      sort: true,
      editable: false,
    },
    {
      dataField: "coordinates0",
      text: "Longitude",
      sort: true,
      editable: false,
    },
    {
      dataField: "last_updated",
      text: "Last Updated",
      sort: true,
      editable: false,
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      editable: false,
    },
    {
      dataField: "share_flag",
      text: "Share Device",
      sort: true,
      formatter: (cell, row) => {
        return (
          <div className="font-weight-bold">
            <label>
              <BootstrapSwitchButton
                checked={row.share_flag}
                offstyle="outline-danger"
                onstyle="outline-success"
                onlabel="Shared"
                offlabel="Not Shared"
                onChange={(checked: boolean) => {
                  setDeviceStatus(checked == true ? "1" : "0");
                  setRowImei(row.imei);
                }}
              />
            </label>
          </div>
        );
      },
    },
  ];

  const defaultSorted = [
    {
      dataField: "name",
      order: "desc",
    },
  ];

  return (
    <div className="bodyColor">
      <div className="table-head">
        <h2 className="table-head-text1">Network Monitoring Dashboard</h2>
        <div className="table-icon">
          <p className="table-head-text2">
            <span className="online-icon"></span>Online
          </p>
          <p className="table-head-text3">
            <span className="offline-icon"></span>Offline
          </p>
        </div>
      </div>

      {!props.done ? (
        <ReactLoading
          type={"spinningBubbles"}
          color={"black"}
          className="react-loading"
        />
      ) : (
        <ToolkitProvider
          bootstrap4
          keyField="serial_no"
          data={props.table.map((obj) => ({
            serial_no: obj.properties.serial_no,
            imei: obj.properties.imei,
            city: obj.properties.city,
            state: obj.properties.state,
            locality: obj.properties.locality,
            coordinates1: obj.geometry.coordinates[1].toFixed(3),
            coordinates0: obj.geometry.coordinates[0].toFixed(3),
            last_updated: [
              obj.properties.last_updated.slice(0, 10),
              "    ",
              obj.properties.last_updated.slice(11, 16),
            ],
            status: obj.properties.status === 1 ? "ONLINE 🟢" : "OFFLINE ​🔴",
            share_flag: obj.properties.share_flag == 1 ? true : false,
          }))}
          // data={products}
          columns={columns}
          defaultSorted={defaultSorted}
          search
        // exportCSV
        >
          {(props) => (
            <div className="custom-Search">
              <div className="search-bar-custom">
                <SearchBar {...props.searchProps} className="searchTerm" />
                <ClearSearchButton
                  {...props.searchProps}
                  className="clear-search-btn"
                />
              </div>
              {/* <ExportCSVButton {...props.csvProps}>
                Export CSV!!
              </ExportCSVButton> */}
              <hr />
              <BootstrapTable {...props.baseProps} />
            </div>
          )}
        </ToolkitProvider>
      )}
    </div>
  );
}
